module.exports = __webpack_public_path__ + "img/masajes.04a14307.svg";